import { Link } from 'react-router';
import { ReactNode } from 'react';
import { AuthLayoutFooter } from './auth-layout-footer';
import { useIsDarkMode } from '@ui/themes/use-is-dark-mode';
import authBgSvg from './auth-bg.svg';
import { useTrans } from '@ui/i18n/use-trans';
import { useSettings } from '@ui/settings/use-settings';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function AuthLayout({ heading, children, message }: AuthPageProps) {
  const { branding } = useSettings();
  const { trans } = useTrans();

  return (
    <main className="flex min-h-screen flex-col items-center justify-center overflow-y-auto bg-alt p-20 md:p-40">
      <div className="w-full max-w-440">
        <div
          className="mb-40 block flex-shrink-0 text-center"
          aria-label={trans({ message: 'Site logo' })}
        >
          <img
            onContextMenu={e => e.preventDefault()}
            src={branding.logo_light || branding?.logo_dark}
            className="m-auto block h-42 w-auto select-none"
            alt=""
          />
        </div>
        <div className="rounded-xl border border-white/5 bg-white/[0.03] p-32 shadow-2xl backdrop-blur-md md:p-48">
          {heading && (
            <h1 className="mb-32 text-center text-3xl font-bold tracking-tight text-white/90">
              {heading}
            </h1>
          )}
          {children}
        </div>
        {message && (
          <div className="mt-32 text-center text-sm font-medium text-muted">
            {message}
          </div>
        )}
      </div>
      <div className="mt-auto pt-40">
        <AuthLayoutFooter />
      </div>
    </main>
  );
}
